__turbopack_context__.v({
  "errorBoundary": "KdSbIG_errorBoundary",
  "feedbackButton": "KdSbIG_feedbackButton",
  "subHeading": "KdSbIG_subHeading",
});
